<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
    >
        <el-form
                :model="dataForm"
                ref="dataForm"
                @keyup.enter.native="dataFormSubmit()"
                label-width="120px"
        >
            <el-form-item label="数据源" prop="datasourceId">
                <el-select v-model="dataForm.datasourceId" placeholder="数据源"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in datasourceList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="表单编号" prop="code">
                <el-input v-model="dataForm.code" placeholder="表单编号"></el-input>
            </el-form-item>
            <el-form-item label="表单标题" prop="title">
                <el-input v-model="dataForm.title" placeholder="表单标题"></el-input>
            </el-form-item>
            <el-form-item label="表单类型" prop="formType">
                <el-select v-model="dataForm.formType" placeholder="表单类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in formTypeList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="业务类型" prop="formType">
            <el-select v-model="dataForm.busType" placeholder="业务类型"
                       style="display: block;margin-bottom: 10px">
              <el-option
                  v-for="item in busTypeList"
                  :key="item.type"
                  :label="item.text"
                  :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="是否支持附件" prop="hasAttach" v-if="dataForm.formType==1">
                <el-select v-model="dataForm.hasAttach" placeholder="是否支持附件"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否支持流程" prop="hasFlow" v-if="dataForm.formType==1">
                <el-select v-model="dataForm.hasFlow" placeholder="是否支持流程"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="流程模板键值" prop="flowTemplateKey" v-if="dataForm.formType==1">
                <el-input
                        v-model="dataForm.flowTemplateKey"
                        placeholder="流程模板键值"
                ></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="dataSort">
                <el-input
                        v-model="dataForm.dataSort"
                        placeholder="排序"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    const fromData = {
        id: "",
        name: "",
        description: "",
        datasourceId: "",
        formType: 1,
        hasAttach: false,
        hasFlow: false,
        flowTemplateKey: '',
        dataStatus: 0,
        dataSort: 10
    }
    export default {
        props: ["mainContentViewHeight"],
        data() {
            return {
                visible: false,
                datasourceList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                formTypeList: [{id: 0, text: '列表'}, {id: 1, text: '明细'}],
                busTypeList: [{type: 'GC', text: '工程建设'}, {type: 'CG', text: '政府采购'}, {type: 'GT', text: '国有产权'}, {type: 'CQ', text: '农村产权'}],
                dataForm: fromData,
            };
        },
        methods: {
            initSelectData() {
                this.$http
                    .post("/customform/datasourceconfig/nodeList",{},{baseURL:  process.env.VUE_APP_proxybaseurl + ''})
                    .then(({data}) => {
                        this.datasourceList = data;
                    });
            },
            init(id) {
                this.dataForm.id = id || "";
                this.visible = true;
                this.initSelectData()
                if (this.dataForm.id) {
                    this.$httpReq({
                        url: "/customform/get?id=" + this.dataForm.id,
                        method: "get",
                        baseURL:  process.env.VUE_APP_proxybaseurl + '',
                    }).then(({data}) => {
                        if (data && data.code === "1") {
                            this.dataForm = data.data;
                        } else {
                            this.dataForm = fromData;
                        }
                    });
                }
            },
            // 表单提交
            dataFormSubmit() {
                this.$httpReq({
                    url: "/customform/save",
                    method: "post",
                    baseURL:  process.env.VUE_APP_proxybaseurl + '',
                    data: this.dataForm,
                }).then(({data}) => {
                    if (data && data.code === "1") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.visible = false;
                                this.$emit("refreshDataList");
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
        },
    };
</script>
